module.exports = __webpack_public_path__ + "static/img/brij-new-logo.bf8f19c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brij-new-logo.svg
// module id = 549
// module chunks = 1